import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  modalWrapper: {
    alignItems: 'center',
    backgroundColor: Theme.withOpacity(Theme.black, 0.8),
    flex: 1,
    justifyContent: 'center',
  },
});
